import { render, staticRenderFns } from "./DC_ZH_5F.vue?vue&type=template&id=34936eb2&scoped=true"
import script from "./DC_ZH_5F.vue?vue&type=script&lang=js"
export * from "./DC_ZH_5F.vue?vue&type=script&lang=js"
import style0 from "./DC_ZH_5F.vue?vue&type=style&index=0&id=34936eb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34936eb2",
  null
  
)

export default component.exports